<template>
  <v-container>
    <!-- fecha -->
    <v-row align="center">
      <v-col class="flex-grow-1 flex-shrink-0"><v-divider></v-divider></v-col>
      <v-col class="flex-grow-0 flex-shrink-1">
        <v-btn @click.stop="$emit('cargar')" icon :class="colorName" dark>
          <v-icon>expand_more</v-icon>
        </v-btn>
      </v-col>
      <v-col class="flex-grow-1 flex-shrink-0"><v-divider></v-divider></v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "mdd-cargar-mas",
  props: ["colorName"]
};
</script>
